// Single-tenant: only Principal Financial Group Azure AD accounts
const config = {
	client_id: process.env.REACT_APP_azureAd_clientId ?? "",
	authority:
		process.env.REACT_APP_azureAd_tenantId ||
		"https://login.microsoftonline.com/3bea478c-1684-4a8c-8e85-045ec54ba430/v2.0",
	redirect_uri: !window.location.origin.includes("localhost")
		? `${window.location.origin}/1hz96kjkf2hlpgy15jwlb5m9qgnxvt8thj/react/`
		: "http://localhost:5300/",
	scope: "openid profile email",
};
export default config;
